/**
 * The slice of the menus' settings a mission cares about (08 §4). The menus only store them;
 * this is where they turn into options for the input, the HUD and the renderer.
 */

import type { HudViewOptions } from '../ui/hud';
import type { Settings } from '../ui/screens';

/** Milk Run 0 .. Suicide 3. Practice, Classic and the Daily Drop have no operation: they play as Standard. */
export const DEFAULT_DIFFICULTY = 1;

export interface MissionSettings {
  runToggle: boolean;
  crawlToggle: boolean;
  /** ROUND7: the crouched walk likewise. */
  sneakToggle: boolean;
  /** Ground-phase game speed: 1, 0.85 or 0.7. The drop always runs at full speed. */
  gameSpeed: number;
  hud: Partial<HudViewOptions>;
  shake: boolean;
  flashes: boolean;
  crt: boolean;
}

export const DEFAULT_MISSION_SETTINGS: MissionSettings = {
  // The same defaults as the menus: hold to run, toggle to crawl and to sneak.
  runToggle: false, crawlToggle: true, sneakToggle: true, gameSpeed: 1, hud: { difficulty: DEFAULT_DIFFICULTY },
  shake: true, flashes: true, crt: false,
};

const SPEEDS = [1, 0.85, 0.7];

/**
 * `difficulty` decides which HUD aids a mission gets (08 §4, the noise ring and the detection arcs
 * thin out as it rises); Options can still force either back on, and that choice is kept.
 */
export function missionSettings(s: Settings, difficulty = DEFAULT_DIFFICULTY): MissionSettings {
  return {
    runToggle: s.runToggle,
    crawlToggle: s.crawlToggle,
    sneakToggle: s.sneakToggle,
    gameSpeed: SPEEDS.includes(s.gameSpeed) ? s.gameSpeed : 1,
    hud: {
      hud1987: s.hud1987, colourBlind: s.colourBlind, noiseRing: s.noiseRing, soundPips: s.soundPips,
      textSize: s.textSize, difficulty,
    },
    shake: s.screenShake,
    flashes: s.flashes,
    crt: s.crtFilter,
  };
}
